import { __assign, __rest } from "tslib";
import React from 'react';
import { Tabs as MaterialTabs, makeStyles, createStyles, } from '@material-ui/core';
import { Tab } from './Tab';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            borderBottom: "1px solid " + theme.palette.grey[400],
        },
        indicator: {
            height: '4px',
        },
    });
});
export var Tabs = function (_a) {
    var children = _a.children, onChange = _a.onChange, props = __rest(_a, ["children", "onChange"]);
    var classes = useStyles();
    return (React.createElement(MaterialTabs, __assign({ classes: classes, indicatorColor: "primary", onChange: onChange }, props), children));
};
Tabs.Tab = Tab;
//# sourceMappingURL=Tabs.js.map